<script setup lang="ts">
import type { IUserInfoExtended } from '~/interfaces/dto/auth/response';
import type { IFormBuilderReference } from '~/interfaces/form/formBuilder';

const userDetails = defineModel<Partial<IUserInfoExtended>>();
const form = ref<IFormBuilderReference>();
const hidePersonalDetails = ref(false);

const emits = defineEmits<{
  (e: 'error', error: string): void;
}>();
</script>

<template>
  <UserInterfaceDynamicFormBuilder
    ref="form"
    v-model="userDetails"
    :container-classes="[{ 'p-2 bg-primary rounded-b-xl': true }]"
    template-name="personal details"
    :should-auto-focus="false"
    :class-binding="[{ 'mb-2': !form?.isEmpty }]"
    @empty-schema="hidePersonalDetails = true"
    @error="emits('error', $event)"
  />
</template>
